export default "__VITE_ASSET__B9q75ng___"